/**
 * Preferences 에서 사용하는 key 값들을 상수로 관리한다.
 */
const PreferencesKeys = {
    KEY_ACCESS_TOKEN: "KEY_ADMIN_ACCESS_TOKEN",
    KEY_USER: "KEY_ADMIN_USER",
    FCM_TOKEN: "ADMIN_FCM_TOKEN",
}

export default PreferencesKeys